import { FC } from 'react'
import { Badge } from 'components/Badge'
import { capitalize } from 'lodash/fp'
import { useIsMobile } from '@wellesley/ui'
import { BellOff, UserX } from 'lucide-react'

type CmpProps = {
  status: 'muted' | 'blocked'
  clasName?: string
  iconOnly?: boolean
}

const StatusLabel: FC<CmpProps> = ({ status, iconOnly = false }) => {
  const isMobile = useIsMobile()
  const icon = status === 'muted' ? <BellOff size={16} /> : <UserX size={16} />

  return (
    <Badge
      variant={status === 'muted' ? 'warning' : 'error'}
      icon={icon}
      data-testid={`profile-status-${status}`}
    >
      {iconOnly || isMobile ? null : capitalize(status)}
    </Badge>
  )
}

export default StatusLabel
